export default __webpack_public_path__ + "static/spark_change_mail_app-684d44eb30442c036b2ed8fd529614fc.png";